import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import axios from "axios";
import { API } from "../../constants/API";
export interface isbnsData {
  _id?: string;
  ISBN?: string;
  FULL_TITLE?: string;
  AUTHOR_1?: string;
}

export interface OptionType {
  value: string;
  label: string;
}

export interface accountObj {
  _id: string;
  ACCOUNT_NAME: string;
  ACCOUNT_NBR: string;
}

interface account {
  accounts?: accountObj[];
  status?: number;
  message?: string;
  page: number;
  limit: number;
  searchStr: string;
  accountNumberScrollPosition: number;
  isLoading: boolean;
  accountHasMore: boolean;
}

interface newIsbnState {
  message?: string;
  hasMoreIsbn: boolean;
  err?: string;
  status?: string;
  selectedISBNS: string[];
  selectedISBNSList: OptionType[];
  selectedTitles: string[];
  selectedTitlesList: OptionType[];
  statusCode: number;
  isbns: isbnsData[];
  isLoading: boolean;
  isbnsString: string;
  accounts: account;
  isbnPage: number;
  isbnLimit: number;
  fetchType: string | undefined;
  numberOptions: OptionType[];
  titleOptions: OptionType[];
}

const initialState: newIsbnState = {
  err: "",
  status: "",
  message: "",
  statusCode: 0,
  isbns: [],
  hasMoreIsbn: false,
  numberOptions:[],
  titleOptions:[],
  isbnPage: 1,
  isbnLimit: 15,
  isbnsString: "",
  selectedISBNS: [],
  selectedISBNSList: [],
  selectedTitles: [],
  selectedTitlesList: [],
  isLoading: false,
  accounts: {
    accounts: [],
    isLoading: false,
    status: 0,
    message: "",
    page: 1,
    limit: 10,
    searchStr: "",
    accountNumberScrollPosition: 0,
    accountHasMore: true,
  },
  fetchType: "",
};

export const fetchIsbnList = createAsyncThunk(
  "isbn/isbn_list",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHISBNSLIST, data);
      console.log(response,'response')
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const fetchAccounts = createAsyncThunk(
  "isbn/fetchAccounts",
  async (
    data: { searchStr: string; page: number; limit: number; oldAccounts: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(API.FETCHACCOUNTS, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const newIsbnSlice = createSlice({
  name: "isbn",
  initialState,
  reducers: {
    removeFetchType: (state) => {
      state.fetchType = undefined;
    },
    addIsbnPage: (state) => {
      if (state.hasMoreIsbn) state.isbnPage += 1;
    },
    resetIsbnPage: (state) => {
      state.isbnPage = initialState.isbnPage;
      state.hasMoreIsbn = true;
    },
    subtractIsbnPage: (state) => {
      if (state.isbnPage > 1) state.isbnPage -= 1;
    },
    UpdateSelectedISBNS: (state, action) => {
      state.selectedISBNS = action.payload;
    },
    UpdateSelectedISBNSList: (state, action) => {
      state.selectedISBNSList = action.payload;
    },
    UpdateSelectedTitles: (state, action) => {
      state.selectedTitles = action.payload;
    },
    UpdateSelectedTitlesList: (state, action) => {
      state.selectedTitlesList = action.payload;
    },
    setIsbnString: (state, action) => {
      if (state.isbns) state.isbnsString = action.payload;
    },
    updateAccountSearchStr: (state, action) => {
      state.accounts.searchStr = action.payload;
    },
    updateAccountPage: (state) => {
      state.accounts.page += 1;
    },
    updateScrollPosition: (state, action) => {
      state.accounts.accountNumberScrollPosition = action.payload;
    },
    updateSearchStr: (state, action) => {
      state.accounts.searchStr = action.payload;
    },
    emptyAccountsScrollPosition: (state) => {
      state.accounts.accountNumberScrollPosition =
        initialState.accounts.accountNumberScrollPosition;
    },
    emptyReducerStates: (state) => {
      state.err = initialState.err;
      state.status = initialState.status;
      state.message = initialState.message;
      state.statusCode = initialState.statusCode;
      state.isbns = initialState.isbns;
      state.isbnsString = initialState.isbnsString;
      state.selectedISBNS = initialState.selectedISBNS;
      state.selectedISBNSList = initialState.selectedISBNSList;
      state.selectedTitles = initialState.selectedTitles;
      state.selectedTitlesList = initialState.selectedTitlesList;
      state.isLoading = initialState.isLoading;
      state.accounts = initialState.accounts;
    },
    setIsbnNumberOptions: (state, action) => {
      state.numberOptions = [...action.payload, ...state.numberOptions]
    },
    setIsbnTitleOptions: (state, action) => {
      state.titleOptions = [...action.payload, ...state.titleOptions]
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIsbnList.pending, (state) => {
        state.status = "loading";
        state.isLoading = true;
      })
      .addCase(fetchIsbnList.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "succeeded";
        if (state.isbns) {
          state.hasMoreIsbn = action.payload.data.hasMore;
          // console.log(action.payload.data.filteredNew,action.payload.data.data,"action.payload.data.filteredNew")
          // if(action.payload.data.filteredNew){
          //   state.isbns = action.payload.data.data;
          //   state.isbnPage = 1;
          // state.page = 1
          // state.selectedRowIndex = 0
          // }
          // else{
          // state.data.push(...action.payload.TitleLists)
          if (action.payload.data.filteredNew || state.isbnPage === 1) {
            state.isbnPage = initialState.isbnPage;
            state.isbns = action.payload.data.data;
            state.fetchType = action.payload.data.fetchType;
          } else {
            const filteredAccounts = action.payload.data.data.filter(
              (isbn: any) =>
                !state.isbns
                  ?.map((stateIsbn) => stateIsbn._id)
                  .includes(isbn._id)
            );
            action.payload.data.data?.length &&
              state.isbns.push(...filteredAccounts);
          }
          state.status = action.payload.status ?? 0;
          state.message = action.payload.data.data?.message ?? "";
          // }
        }
        state.isLoading = false;
      })
      .addCase(fetchIsbnList.rejected, (state, action: PayloadAction<any>) => {
        state.status = "failed";
        state.isLoading = false;
        if (state.isbns) {
          state.statusCode = action.payload.status;
          state.message = action.payload.data?.message ?? "";
        }
      });

    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.accounts.isLoading = true;
      })
      .addCase(fetchAccounts.fulfilled, (state, action: PayloadAction<any>) => {
        state.accounts.isLoading = false;
        state.accounts.accountHasMore = action.payload.data.hasMore;
        if (state.accounts.accounts)
          state.accounts.accounts.push(...action.payload.data.data);
      })
      .addCase(fetchAccounts.rejected, (state, action: PayloadAction<any>) => {
        state.accounts.isLoading = false;
        if (state.accounts) {
          state.accounts.status = action.payload.status;
          state.accounts.message = action.payload.data?.message ?? "";
        }
      });
  },
});

export const {
  UpdateSelectedISBNSList,
  UpdateSelectedISBNS,
  UpdateSelectedTitlesList,
  UpdateSelectedTitles,
  setIsbnString,
  updateAccountSearchStr,
  updateAccountPage,
  updateScrollPosition,
  updateSearchStr,
  emptyAccountsScrollPosition,
  emptyReducerStates,
  addIsbnPage,
  subtractIsbnPage,
  resetIsbnPage,
  removeFetchType,
  setIsbnNumberOptions,
  setIsbnTitleOptions
} = newIsbnSlice.actions;

export default newIsbnSlice.reducer;
